/* eslint-disable import/no-anonymous-default-export */
export default {
  common: {
    noResults: "No results found.",
    actions: "Actions",
    add: "Add",
    edit: "Edit",
    view: "View",
    back: "Back",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    ok: "OK",
    confirm: "Confirm",
    deleteConfirmMsg: "Are you sure you want to delete?",
    no: "No",
    yes: "Yes",
    visible: "Visible",
    hidden: "Hidden",
    on: "On",
    off: "Off",
    noDataAvailable: "No Data Available",
    pagination: {
      rowsPerPage: "Rows per page:",
      range: "{{from}}–{{to}} of {{total}}",
      page: "Page",
      pageInput: "Page number",
      ofPages: "of {{total}}",
      firstPage: "First page",
      previousPage: "Previous page",
      nextPage: "Next page",
      lastPage: "Last page",
      invalidPage: "Enter a page from 1 to {{total}}",
    },
    reason: "Reason",
    createdBy: "Created By",
    modifiedBy: "Modified By",
    close: "Close",
    loadingText: "We are loading the data for you. Please wait.",
    search: "Search",
    paracetamol: "paracetamol",
    disable: "Disable",
    disabled: "Disabled",
    enable: "Enable",
    enabled: "Enabled",
    editable: "Editable",
    readOnly: "Read Only",
    tenant: "Tenant",
    languageSwitch: "Language Switch",
    ac: "Admin Center",
    dashboard: "Dashboard",
    signOut: "Sign out",
    revert: "Revert",
    list: "List",
    showDeletedRecords: "Show Deleted Records",
    recordID: "Record ID",
    recordName: "Record Name",
    description: "Description",
    status: "Status",
    association: "Association",
    type: "Type",
    mandatory: "Mandatory",
    optional: "Optional",
    information: "Information",
    createdDate: "Created Date",
    modifiedDate: "Modified Date",
    basicInformation: "Basic Information",
    details: "Details",
    level: "Level",
    update: "Update",
    lock: "Lock",
    unlock: "Unlock",
    typeofAssociation: "Type of Association",
    recordDeleteTip:
      "Record <b>cannot be deleted </b> because it has the below dependencies.",
    recordStatusTip:
      "Status <b>cannot be changed </b> because it has the below dependencies.",
    comments: "Comments",
    clear: "Clear",
    apply: "Apply",
    clearFilter: "Clear Filters",
    downloadPDF: "Download as PDF",
    downloadCSV: "Download as CSV",
    downloadExcel: "Download as Excel",
    tokenIsExpired: "Your token is expired, please login again",
    collapse: "Collapse",
    expand: "Expand",
    continue: "Continue",
    tip: {
      addSuccess: "Add successfully.",
      addFailed: "Add failed.",
      updateSuccess: "Update successfully.",
      updateFailed: "Update failed.",
      revertSuccess: "Revert successfully.",
      revertFailed: "Revert failed.",
      deleteSuccess: "Delete successfully.",
      deleteFailed: "Delete failed.",
      deletion: "Please enter a reason for deletion.",
      limit_2000: "The input exceeds the maximum limit of 2,000 characters.",
      selectOneItem: "Please select one item.",
      selectTarget: "Please select target first.",
      jsonError: 'Incorrect JSON format. Please enter the correct JSON format.'
    },
    createdDateAndTime: "Created Date and Time",
    modifiedDateAndTime: "Modified Date and Time",
    audit: "Audit",
    deleteSelected: "Delete Selected",
    next: "Next",
    submit: "Submit",
    import: "Import",
    export: "Export",
    importInfo: "Import info",
    importTips: "If {{type}} already exists, the imported data will overwrite {{name}} current information",
    downloadTemplate: "Download Template",
    unsavedChange: {
      title: "Unsaved changes",
      content: "Are you sure you want to leave this page? Any unsaved changes will be lost."
    },
    importFile: {
      tips: {
        noFileChoose: "Please choose a file or click cancel to exit this screen.",
        fileFormatError: "File type is not allowed.",
        fileDuplicate: "Please check and remove duplicate files.",
        importingData: "We are importing your data. Please wait for a few seconds.",
        importSuccess: "File imported successfully.",
        uploadSuccess: "The file has been uploaded successfully.",
        importFailure: "Failure Count",
        moreThanOne: "You cannot attach more than 1 files",
        FailToImport: "File import failed. Please make sure the file is valid and try again.",
        contentIsTooLarge: "File content is too large to import. Please reduce the file size and try again.",
        importInProgress: "An import is already running for this module. Wait for it to finish, then try again.",
        importTimeout: "The import is taking longer than expected. Reopen this page later to check the result.",
      }
    },
    businessRule: {
      dependencyType: 'Dependency Type',
      title: "Setup Business Rules",
      source: 'Source',
      name: 'Name',
      field: 'Field',
      rule: 'Rule',
      values: 'Values',
      required: '{{fieldName}} is required',
      exists: 'Exists',
      equals: 'Equals',
      notEquals: 'Not Equals',
      in: 'In',
      notIn: 'Not In',
      where: 'Where',
      module: 'Module',
      group: 'Group',
      menu: 'Menu'
    },
    jsonLabel: 'JSON',
    avatar: "Profile",
    upload: {
      noFileChosen: "No file is chosen",
      buttonLabel: "Choose file",
      header: "Please Drag & Drop files here",
      buttonRemoveLabel: "Remove all",
      or: "Only .xls and .xlsx files are supported"
    },
    loading: {
      exportData: "We are currently exporting your data. Please check your downloads once its completed.",
      exportDataTip: "We are currently exporting your data. Please check your downloads once its completed.",
      downloadTemplate: "We are currently downloading the template. Please check your downloads once its completed."
    },
    tips: {
      downloadFailed: "Failed to download the file. Please try again."
    },
    required: "required",
    order: "Order",
    rule: "Rule"
  },
  validation: {
    isRequired: "is required"
  },
  commonFilter: {
    filters: "Filters",
    filterby: "Filter by",
    select: "Select",
    search: "Search",
    clearFilters: "Clear Filters"
  },
  personage: {
    tip: {
      pwUpdateSuccess: "Password has been changed successfully.",
      pwUpdateLimit:
        "You have exceeded the limit to change your password. Please contact the system administrator.",
    },
  },
  menu: {
    searchModule: "Search Module",
    modules: "Modules",
    showMenu: "Show menu",
    hideSideMenu: "Hide menu",
    showNavigationSidebar: "Show navigation sidebar",
    uam: "UAM",
    users: "Users",
    roles: "Roles",
    userGroups: "User Groups",
    accessControl: "Access Control",
    distribution: "Distribution List",
    cm: "Config. Manager",
    menuManager: "Menu Manager",
    formManager: "Form Manager",
    gridManager: "Grid Manager",
    wizardManager: "Wizard Manager",
    audit: "Audit Reports",
    notifications: "Notifications",
    templates: "Templates",
    payloads: "Payloads",
    tasks: "Tasks",
    history: "History",
    importACL: "Import ACL (Excel)",
    importUser: "Import User",
    importGroup: "Import User Group (Excel)",
    importRole: "Import Role (Excel)",
    workflowManager: "Workflow Manager",
    knowledgeManager: "Knowledge Manager",
    processManager: "Process Manager",
    eventManager: "Event Manager",
    docsManager: "Docs Manager",
    uiManager: "UI Manager",
    archiveManager: "Archive Manager",
    planAndAutomation: "Plan & Automation",
    platformRelatedReports: "Reports",
    taskManager: "Task Manager",
    templateManager: "Template Manager",
    templateAutoLauncher: "Template AutoLauncher",
    importDistribution: "Import Distribution",
    clients: "Clients",
    scim: "SCIM",
  },
  scimManager: {
    title: "SCIM Configuration",
    baseUrl: "SCIM Base URL",
    secretToken: "Secret Token",
    status: "Status",
    expiresAt: "Expires At",
    validUntil: "Valid until",
    neverExpires: "Does not expire",
    graceExpiresAt: "Previous token grace until",
    defaultGraceHours: "Default grace period (hours)",
    generate: "Generate",
    rotate: "Rotate",
    revoke: "Revoke",
    delete: "Delete",
    revokeTitle: "Revoke SCIM Credential",
    deleteTitle: "Delete SCIM Credential",
    copyBaseUrl: "Copy Base URL",
    copySecret: "Copy Secret Token",
    disabledMessage:
      "SCIM is not enabled for this tenant. Contact your platform administrator.",
    secretOnceWarning:
      "This secret is shown only once. Copy it now and store it securely. You will not be able to view it again.",
    generateTitle: "Generate SCIM credential",
    rotateTitle: "Rotate SCIM credential",
    revokeConfirm:
      "Revoke this SCIM credential? Requests using this token will stop immediately.",
    deleteConfirm:
      "Delete this SCIM credential from the list? This cannot be undone.",
    expiresInDays: "Token expiration",
    gracePeriodHours: "Grace period for previous token (hours)",
    tokenExpiresIn: "Token expires in",
    newTokenExpiresIn: "New token expires in",
    previousTokenValidFor: "Previous token remains valid for (hours)",
    tokenExpirationTooltip:
      "Sets how long this generated token remains valid. Select Does not expire for no calendar expiration.",
    newTokenExpirationTooltip:
      "Sets how long the new token generated by this rotation remains valid.",
    previousTokenGraceTooltip:
      "Sets how long the token being rotated remains valid. Select 0 to revoke it immediately.",
    secretGenerated: "SCIM credential generated.",
    secretRotated: "SCIM credential rotated.",
    revoked: "SCIM credential revoked.",
    deleted: "SCIM credential deleted.",
    baseUrlCopied: "SCIM Base URL copied to clipboard.",
    secretCopied: "Secret Token copied to clipboard.",
    close: "Close",
    credentialsList: "Credentials",
    credentialsTimeHint: "Times are shown in your regional time zone.",
    noCredentials: "No credentials yet. Generate a token to get started.",
    rotatedAt: "Rotated At",
    statusActive: "Active",
    statusGrace: "Previous (still valid)",
    statusExpired: "Expired",
    statusRevoked: "Revoked",
    graceBanner:
      "Previous token(s) are still accepted until the time(s) below. Update your IdP Secret Token before then.",
    remainingInDays: "in {{count}} day(s)",
    remainingInHours: "in {{count}} hour(s)",
    remainingSoon: "less than 1 hour",
    remainingPast: "ended",
    quotaWarning:
      "User quota is {{used}} of {{quota}} used. New SCIM users will fail once the limit is reached. Updates to existing users will continue.",
    quotaReachedBody:
      "SCIM will not create new users. Updates to existing users can still succeed.",
  },
  menuManager: {
    listLabel: "{{type}} List",
    label: "Menu List",
    menuName: "Menu Name",
    group: "Group",
    groupDisplayName: "Group Display Name",
    module: "Module",
    domain: "Domain",
    type: "Type",
    status: "Status",
    visibility: "Visibility",
    generateGrid: "Generate Grid",
    generateRecordId: "Generate Record ID",
    linkItem: "Link Item",
    requiresGenerateGridEnabled: "Requires 'Generate Grid' to be enabled.",
    goToMenuList: "Go to Menu List",
    addGroup: "Add Group",
    addMenu: "Add Menu",
    sectionOrder: "Order",
    menu: "Menu",
    labelPath: 'Tree Label Field',
    parentHierarchy: 'Child Hierarchy',
    setupParentHierarchy: 'Setup Child Hierarchy',
    selectTheLabelPathField: "Select the Tree Label Field",
    linkLabelPathTip: "Select the field for this menu to display on the Registration/Application wizard.",
    verify: "{{fieldName}} is required",
    moduleNotAvailable: 'Previous module not available.',
    deleteGroupConfirmMsg: 'Are you sure you want to delete the group? All the associated menus will also be deleted.',
    deleteMenuConfirmMsg: 'Are you sure you want to delete the menu? All the associated forms and grids will also be deleted.',
    inheritIdentifier: 'Inherit Identifier',
    setupInheritIdentifier: 'Setup Inherit Identifier',
    badgeHeader: 'Header Badge',
    setupBadgeHeader: 'Setup Header Badge',
    usedInLinkedRecords: 'Used in Linked Records',
    usedInLinkedRecordsHelpTip: 'Check this to use this field as the identifier used in cross-module Linked Records query. Please note: This is a permanent change. Once checked, this setting cannot be reversed, and the field itself cannot be deleted or disabled.',
    linkedRecordConfirmMessage: 'The field {{fieldName}} is permanently used in cross-module Linked Records query. Therefore, this setting cannot be reversed.',
    linkedRecordIdentifierConfirmMessage: 'You are about to make {{fieldName}} a permanent Linked Records Identifier. This action cannot be undone. Are you sure you want to continue?',
    separatorRequired: "Please fill the Separator first.",
    separator: "Separator",
    setupTreeLabelField: "Setup Tree Label Field",
    fullExport: "Full Export",
    menuExport: "Menu Export",
    fullImport: "Full Import",
    menuImport: "Menu Import",
    importWizardOverrideWarning: "This will overwrite related configurations in Wizard Manager and Form Manager.",
    importFullOverrideWarning: "This will overwrite all configurations, including related settings in Menu Manager, Wizard Manager, Form Manager, and Grid Manager.",
    importMenuOverrideWarning: "This will overwrite related configurations in Menu Manager, Form Manager, and Grid Manager.",
    goToFieldList: "Go to Field List",
    changeTypeConfirmMessage: "You are about to change the Type for {{menuName}}. This will clear the existing Business Rules, and you will need to set them up again manually. Are you sure you want to continue?",
    statusDisableHelpTip: "Menu cannot be disabled if it contains mandatory, conditional mandatory or auto-tagged fields.",
    visibilityDisableHelpTip: "Visibility is set to hidden when the Status field is disabled.",
    objectName: "Object Name",
    objectDisplayName: "Object Display Name",
    objectMainGridConfig: "Object Main Grid Config",
    objectMainGridSourceFormat:
      "Form Name · Type · Module > Object > Group(Wizard)",
    setupObjectMainGrid: "Configure Object Main Grid",
    mainGridName: "Main Grid Name",
    mainGridConfigurationTitle: "Main Grid Configuration",
    mainGridConfigurationDescription:
      "Define grid hierarchy nodes, assign a source per node, and choose visible columns.",
    switchObjectUnsavedWarning:
      "Switching the object will discard unsaved changes. Continue?",
    switchObjectStay: "Stay",
    loadConfigFailed:
      "Failed to load Object Main Grid configuration. Please try again.",
    objectHeaderBadgeConfig: "Object Header Badge Config",
    setupObjectHeaderBadge: "Setup Object Header Badge",
    addObjectHeaderBadgeRule: "Add Rule",
    objectHeaderBadgeSourceHint:
      "Form Name · Type · Module > Object > Group(Step)",
    objectHeaderBadgeSourceSearchPlaceholder: "Search by Form/Grid name",
    loadObjectHeaderBadgeFailed:
      "Failed to load Object Header Badge configuration. Please try again.",
  },
  gridManager: {
    label: "Grid List",
    gridName: "Grid Name",
    module: "Module",
    domain: "Domain",
    sectionMenu: "Section/Menu",
    group: "Group",
    form: {
      order: "Order",
      column: "Column",
      type: "Type",
      gridAvailability: "Grid Availability",
      visibility: "Visibility",
      groupBy: "Group by",
      sortBy: "Sort by",
      gridDensity: "Grid density",
      pageSize: "Page size",
      none: "--None--",
      asc: "Asc",
      desc: "Desc",
      custom: "Custom",
      customPageSizeInput: "Custom page size",
      customPageSizeHint: "Custom: {{count}} rows per page",
      customPageSizeRequired: "Custom: Page size is required",
      customPageSizeMoreThan0: "Custom: Page size must be more than 0",
      pageSizeRows: "{{count}} rows",
      density: {
        Compact: "Compact",
        Standard: "Standard",
        Comfortable: "Comfortable",
      },
    },
  },
  wizardManager: {
    listLabel: "Wizard List",
    wizardName: "Wizard Name",
    module: "Module",
    domain: "Domain",
    section: "Section",
    definition: "Definition",
    wizard: "Wizard",
    name: "Name",
    step: "Step",
    type: "Type",
    status: "Status",
    visibility: "Visibility",
    generateGrid: "Generate Grid",
    addGroup: "Add Group",
    addMenu: "Add Menu",
    menu: "Menu",
    sectionOrder: "Order",
    displayName: "Display Name",
    wizardDisplayName: "Wizard Display Name",
    description: "Description",
    addWizard: "Add Wizard",
    goToStepList: "Go to Step List",
    addWizardGroup: "Add Wizard Group",
    addWizardGroupForm: "Add Wizard Group Form",
    addWizardGroupFormField: "Add Wizard Group Form Field",
    deleteWizardConfirmMsg: 'Are you sure you want to delete the wizard? All the associated steps will also be deleted.',
    deleteStepConfirmMsg: 'Are you sure you want to delete the step? All the associated forms will also be deleted.',
    statusDisableHelpTip: "Step cannot be disabled if it contains mandatory, conditional mandatory or auto-tagged fields.",
    visibilityDisableHelpTip: "Visibility is set to hidden when the Status field is disabled.",
  },
  formManager: {
    label: "Form List",
    formName: "Form Name",
    usageType: "Usage Type",
    module: "Module",
    domain: "Domain",
    section: "Section",
    groupWizard: "Group/Wizard",
    groupWizardDisplayName: "Group/Wizard Display Name",
    groupDisplayName: "Group Display Name",
    definition: "Definition",
    field: {
      label: "Form Field List",
      order: "Order",
      fieldName: "Field Name",
      fieldType: "Field Type",
      type: "Type",
      permission: "Permission",
      status: "Status",
      visibility: "Visibility",
      tenantLabel: "Tenant Label",
      infoText: "Info Text",
      regulations: "Regulations",
      addField: "Add Field",
      span: "Span",
      rows: "Rows",
      length: "Character Limit",
      dataSource: "Data Source",
      businessRule: "Business Rule",
      conditionalReadOnly: "Conditional Read Only",
      conditionalMandatory: "Conditional Mandatory",
      linkField: "Link Field",
      linkCascading: "Link Cascading Field",
      editJson: "Edit JSON",
      addJson: "Add JSON",
      jsonLabel: 'JSON',
      addRule: "Add Rule",
      productType: "Type",
      productSubcategory: "Subcategory",
      productCategory: "Category",
      minimum: "Minimum",
      maximum: "Maximum",
      placeholder: "Placeholder",
      regularExpression: "Regular Expression",
      minimumLength: "Minimum Length",
      maximumLength: "Maximum Length",
      minimumDate: "Minimum Date",
      maximumDate: "Maximum Date",
      invalidRegularExpression: "Invalid regular expression. Please check and retry.",
      changeDataSourceConfirmMessage: "You are about to change the Data Source for {{fieldName}}. This will clear the existing Grid Criteria, and you will need to set them up again manually. Are you sure you want to continue?",
      autoTaggingIdentifier: "Auto-Tagging Identifier",
      autoTaggingIdentifierHelpTip: "Turn this on to automatically use this field as an identifier and tag for every record in this business module. Please note: This is a permanent change. Once enabled, this setting cannot be reversed, and the field itself cannot be deleted or disabled.",
      autoTaggingIdentifierConfirmMessage: "Your are about to make {{fieldName}} a permanent Auto-Tagging Identifier. This action cannot be undone and the field cannot be deleted or disabled. \n\nAre you sure you want to continue?",
      autoTaggingEnabledTooltip: "Auto-Tagging is permanently enabled for field {{fieldName}}. Therefore, this setting cannot be deleted or disabled.",
      selectionMode: "Selection Mode",
      single: "Single",
      multiple: "Multiple",
      valueGeneratedBySystem: "Value Generated by System",
      sourceField: "Source Field",
      property: "Property",
      moduleSpecific: "Module Specific",
      statusDisableHelpTip: "Field should not be able to disabled if the field is mandatory or conditional mandatory.",
      visibilityDisableHelpTip: "Visibility is set to hidden when the Status field is disabled.",
      notFoundById: "Fields not found in current tenant",
      staticText: {
        textVariant: "Text Variant",
        heading1: "Heading 1",
        heading2: "Heading 2",
        heading3: "Heading 3",
        heading4: "Heading 4",
        heading5: "Heading 5",
        heading6: "Heading 6",
        subtitle1: "subtitle 1",
        subtitle2: "subtitle 2",
        textVariantRequired: "Text Variant is required",
      },
      separatorLine: {
        visualAndLayout: "Visual & Layout",
        lineStyle: "Line Style",
        verticalSpacing: "Vertical Spacing",
        indentation: "Indentation",
        solid: "Solid",
        dashed: "Dashed",
        none: "None",
        small: "Small",
        medium: "Medium",
        large: "Large",
        fullWidth: "Full Width",
        inset: "Inset",
        middle: "Middle",
        embeddedText: "Embedded Text",
        enableEmbeddedText: "Enable Embedded Text",
        textValue: "Text Value",
        textValuePlaceholder: "Enter text to display on the separator line",
        textAlignment: "Text Alignment",
        textStyle: "Text Style",
        left: "Left",
        center: "Center",
        right: "Right",
        middleSize: "Middle",
        visualLayoutRequired: "Line Style, Vertical Spacing, and Indentation are required",
        textValueRequired: "Text Value is required when Embedded Text is enabled",
      },
      compositeComponent: {
        gridConfigurationTitle: "Composite Grid Configuration",
        gridConfigurationHelp:
          "Rename grid nodes and reorder child/sibling nodes under the parent grid.",
        hierarchy: "Hierarchy",
        emptyHint: "No components yet. Use Add child to create the first one.",
        noSelection: "Select a component to configure its source and visible fields.",
        rootHint: "Please add nodes in the hierarchy area on the left first, so you can proceed to configure the source and visible fields for each node.",
        source: "Source",
        visibleFields: "Visible Fields",
        visibleFieldsHelp: "Check columns to show. Drag to reorder.",
        column: "Column",
        columnType: "Type",
        toggleAllVisible: "Select all / deselect all",
        addChildTitle: "Add child component",
        addSiblingTitle: "Add sibling component",
        renameTitle: "Rename component",
        nameRequired: "Name is required.",
        nameDuplicate: "A sibling with this name already exists.",
        saveWarningTitle: "Confirm",
        emptyStructureWarning:
          "The composite component structure is empty. No component nodes have been configured.\nDo you want to save anyway?",
        missingSourceWarning:
          "One or more component nodes have no Source selected.\nDo you want to save anyway?",
        deleteTitle: "Delete component",
        deleteMessage: "Delete this component?",
        descendantWarning: "This component and all of its nested components will be removed.",
        toolbar: {
          addChild: "Add child",
          addSibling: "Add sibling",
          edit: "Edit",
          delete: "Delete",
          moveUp: "Move up",
          moveDown: "Move down",
        },
      },
    },
    tip: {
      jsonError: 'Incorrect JSON format. Please enter the correct JSON format.'
    },
    businessRule: {
      title: "Setup Business Rules",
      field: 'Field',
      rule: 'Rule',
      values: 'Values',
      required: '{{fieldName}} is required',
      exists: 'Exists',
      equals: 'Equals',
      notEquals: 'Not Equals',
      in: 'In',
      notIn: 'Not In'
    },
    linkCascadingField: {
      title: "Link Cascading Field",
      label: "Cascading Field",
      helpTip: "Only related concepts in Knowledge Manager can be used as cascading fields.",
    },
    linkField: {
      title: "Setup Link Field",
    },
    conditionalReadOnly: {
      title: "Setup Conditional Read Only Rules",
    },
    conditionalMandatory: {
      title: "Setup Conditional Mandatory Rules",
    },
    dependencyValidation: {
      label: "Dependency Validation",
      title: "Setup Dependency Validation",
      helpTip: "Avoid configuring conflicting rules between Dependency Validation and field-level Validation, as contradictory validations may prevent the form from being saved.",
      compareWithType: "Compare With",
      currentDate: "Current Date",
    },
    duplicateValidation: {
      title: "Setup Duplicate Validation Rules",
      action: "Duplicate Validation Rule",
      compositions: "Compositions",
    },
    gridCriteria: {
      title: "Setup Grid Criteria",
      label: "Grid Criteria",
      addCriteria: "Add Criteria",
      addRule: "Add Rule",
      andOr: "And/Or",
      module: "Module",
      type: "Value Source",
      groupWizard: "Group",
      menuStep: "Menu",
      field: "Field",
      rule: "Rule",
      values: "Values",
      menuGroup: "Menu Group",
      wizard: "Wizard",
      is: "Is",
      exists: "Exists",
      equals: "Equals",
      notEquals: "Not Equals",
      in: "In",
      notIn: "Not In",
      where: "Where",
      required: "{{fieldName}} is required",
      and: "And",
      or: "Or",
      wizardReference: "Wizard Reference",
      clickToConfigure: "Click to configure…",
      step: "Step",
      fromMenuGroup: "From Menu Group",
      fromWizard: "From Wizard",
    },
    extraJson: {
      action: "Customize Form JSON"
    }
  },
  userManager: {
    users: "Users",
    associateUser: 'Associate Users',
    description:
      "Users Module will help you create and manage application users.",
    profileDetails: "Profile Details",
    loginGroupDetails: "Login Group Details",
    reassignUser: "Reassign User",
    resetPassword: "Reset Password",
    sendActivationLink: "Send Activation Link",
    setAsPrimary: "Set as Primary",
    reassignPrimaryTenant: "Reassign Primary Tenant",
    deleteUser: "The selected user will be deleted. Do you wish to proceed?",
    disassociateUser: "The selected user will be disassociated from this tenant. Do you wish to proceed?",
    lockUser: "Are you sure you want to lock the user?",
    unLockUser: "Are you sure you want to unlock the user?",
    unlockUserTip:
      "Performing this action will unlock and allow the user to log in to the application.",
    lockUserTip:
      "Performing this action will lock and prevent the user from login to the application.",
    deleteUserWithDependency:
      "Are you sure you want to delete this user as it has dependencies?",
    onlyAssociatedUsersCanBeSetAsPrimary: "Only the associated users can be set as primary users.",
    pleaseDeselectPrimaryUsersAndRetry: "Please deselect the currently selected primary users and retry.",
    someSelectedUsersAreInactiveOrArchived: "Some selected users are inactive or archived and cannot be set as primary users.",
    pleaseDeselectInactiveAndArchivedUsersAndTryAgain: "Please deselect the inactive and archived users and try again.",
    userQuotaReached:
      "The maximum number of users is {{quota}}. If you need to add more users, please contact the Freya Fusion Support Team.",
    userQuotaChipUsed: "{{used}} of {{quota}} used",
    userQuotaRemaining: "{{remaining}} remaining",
    userQuotaReachedLabel: "Quota reached",
    userQuotaTooltipStats: "{{used}} used of {{quota}} · {{remaining}} remaining",
    userQuotaTooltipStatsReached: "{{used}} used of {{quota}} · Quota reached",
    userQuotaIncludedLabel: "Included",
    userQuotaIncludedRule:
      "In-Draft, Active, Inactive (including Locked), and associated users",
    userQuotaExcludedLabel: "Excluded",
    userQuotaExcludedRule: "Deleted and Archived",
    userQuotaImportNotImported:
      "The entire file was not imported. No users were created and no existing users were updated.",
    userQuotaImportRemaining: "{{remaining}} user quota remaining",
    userQuotaImportNewUsers: "{{count}} new users in this file",
    userQuotaImportUpdates: "{{count}} updates not applied",
    userQuotaImportDownloadDetails: "Download details ({{count}} new users)",
    userQuotaAssociateNoneAssociated:
      "None of the selected users were associated. Remaining quota is {{remaining}}; {{selected}} users were selected.",
    user: {
      label: "User",
      emailID: "Email ID",
      firstName: "First Name",
      lastName: "Last Name",
      middleName: "Middle Name",
      countryGroup: "Country Group",
      country: "Country",
      mobile: "Mobile No.",
      phone: "Phone No.",
      city: "City",
      loginGroup: "Login Group",
      businessUnit: "Business Unit",
      authenticationMechanism: "Authentication Mechanism",
      disassociateUser: 'Disassociate User',
      mfaConfig: "MFA Configuration",
      mfaConfigTip: "The MFA configuration will only apply to users whose original authentication mechanism is SSO. For users who originally use login password, their existing MFA settings will remain unchanged.",
      loginGroupConfirm: "The login group cannot be changed once saved.\nAre you sure you want to proceed with the selected login group?",
      accountLock: "Account Lock",
      accountLocked: "Locked",
      accountUnlocked: "Unlocked",
    },
    tip: {
      updateStatusSuccess: "User Status has been updated successfully.",
      disassociatedSuccess: "User has been disassociated successfully.",
      associatedSuccess: "Users have been associated successfully.",
      usersAssociatedSuccess: "Users have been associated successfully.",
      exists: "User already exists.",
      updateSuccess: "User has been updated successfully.",
      intructionsSent:
        "Instructions for setting up the account have been sent to the user.",
      emailExists: "Email ID already exists. Please choose a different one.",
      deleteSuccess: "User has been deleted successfully.",
      sendSetupPswEmail:
        "Password reset email has been sent successfully to user.",
      sendActivationLink: "Activation link has been sent successfully to user.",
      setPrimarySuccess: "Primary users set successfully.",
      lockedSuccess: "User has been locked successfully.",
      unlockedSuccess: "User has been unlocked successfully.",
      lockedFailed: "Locking failed.",
      unlockedFailed: "Unlocking failed.",
    },
    verify: {
      phone: "Please enter the correct phone number",
      mobile: "Please enter the correct mobile number",
      email: "Please enter the correct Email ID",
      emailEmpty: "Email ID is required",
      firstNameEmpty: "First Name is required",
      lastNameEmpty: "Last Name is required",
      loginGroupEmpty: "Select the Login Group",
      mechanismEmpty: "Select the Authentication Mechanism",
    },
  },
  roleManager: {
    roles: "Roles",
    description:
      "Roles Module will help you combine one or multiple set of permissions together for users.",
    profileDetails: "Profile Details",
    loginGroupDetails: "Login Group Details",
    deleteRole: "The selected role will be deleted. Do you wish to proceed?",
    importRoleAndACL: "Import Role with ACLs (JSON)",
    importRoleAclConfirmTitle: "Import Role with ACLs",
    importRoleAclConfirmP1:
      "Please ensure all related ACLs and Privileges have been successfully imported before you continue. You will be asked to select a JSON file.",
    importRoleAclConfirmWarning:
      "This JSON import can override existing configuration.",
    importRoleAclConfirmP2:
      "Depending on the file, matching records may be replaced for:",
    importRoleAclConfirmLi1: "Roles",
    importRoleAclConfirmLi2: "Role - Access Controls (ACLs) mapping",
    exportRoleWithPrivilegesJson: "Export Role with ACLs (JSON)",
    role: {
      label: "Role",
      roleName: "Role Name",
      roleType: "Role Type",
      roleLevel: "Role Level",
      roleLevelTip: "A lower number means higher privilege.",
      source: "Source"
    },
    tip: {
      updateStatusSuccess: "Role Status has been updated successfully.",
      disassociatedSuccess: "Role has been disassociated successfully.",
      associatedSuccess: "Role has been associated successfully.",
      exists: "Role already exists.",
      addSuccess: "Role has been created successfully.",
      updateSuccess: "Role has been updated successfully.",
      deleteSuccess: "Role has been deleted successfully.",
      exportRoleConfigSuccess: "Role configuration has been exported successfully.",
    },
  },
  userGroupManager: {
    userGroups: "User Groups",
    description: "Group similar type of users together for your ease here.",
    deleteUserGroup:
      "The selected user group group will be deleted. Do you wish to proceed?",
    importUserGroupAndRole: "Import User Group with Roles (JSON)",
    importGroupRoleConfirmTitle: "Import User Group with Roles",
    importGroupRoleConfirmP1:
      "Please ensure all corresponding Roles have been successfully imported before you continue. You will be asked to select a JSON file.",
    importGroupRoleConfirmWarning:
      "This JSON import can override existing configuration.",
    importGroupRoleConfirmP2:
      "Depending on the file, matching records may be replaced for:",
    importGroupRoleConfirmLi1: "User Groups",
    importGroupRoleConfirmLi2: "User Group - Roles mapping",
    importGroupRoleConfirmLi3: "Tags",
    importGroupRoleConfirmLi4: "Dimensions",
    exportUserGroupWithRolesJson: "Export User Group with Roles (JSON)",
    userGroup: {
      label: "User Group",
      userGroupName: "User Group Name",
    },
    dimensions: "Dimensions",
    dimension: "Dimension",
    values: "Values",
    addDimension: "+ Add Dimension",
    searchDimension: "Search dimension",
    searchValues: "Search values",
    selectDimensionFirst: "Select a dimension first",
    noDimensionMatch: "No dimension match",
    noValueMatch: "No values match",
    noOptions: "No options",
    noDataAvailable: "No data available",
    noResultsFound: "No results found.",
    removeDimension: "Remove",
    kmVersion: {
      title: "Knowledge Manager Data Version",
      description: "The Knowledge Manager version used for this user group’s dimensions and values",
      kmV2: "KM 2.0",
      kmV2Hint: "Default",
      kmV1: "KM 1.0",
      kmV1Hint: "KM 1.0 data only",
      kmV12: "KM 1.0 and KM 2.0",
      kmV12Hint: "Data from both versions",
      viewKmV2: "KM version 2.0",
      viewKmV1: "KM version 1.0",
      viewKmV12: "KM version 1.0 and 2.0",
      column: "Dimensions KM version",
      removeWarning:
        "These selected values are not in {{version}} and will be removed. The change is saved only when Save is clicked.",
      selectAllWarning: "Select all will also be cleared.",
      cancel: "Cancel",
      continue: "Continue",
    },
    tip: {
      updateStatusSuccess: "User Group Status has been updated successfully.",
      updateSuccess: "User Group has been updated successfully.",
      dimensionsSaved: "Dimensions saved successfully.",
      addSuccess: "User Group has been created successfully.",
      exists: "User Group already exists.",
      associatedSuccess: "User Group has been associated successfully.",
      disassociatedSuccess: "User Group has been disassociated successfully.",
      deleteSuccess: "User Group has been deleted successfully.",
      exportGroupConfigSuccess: "User group configuration has been exported successfully.",
    },
  },
  accessControlManager: {
    accessControls: "Access Controls",
    description:
      "Access Control Module will help you create a specific set of permissions for users.",
    privilege: "Privilege",
    deleteACL:
      "The selected access control will be deleted. Do you wish to proceed?",
    importACLWithPrivilegeDetails: "Import ACL with Privileges (JSON)",
    importACLWithoutPrivilegeDetails: "Import ACL (Excel)",
    importAclJsonConfirmTitle: "Import ACL with Privileges",
    importAclJsonConfirmP1:
      "You will be asked to select a JSON configuration file.",
    importAclJsonConfirmWarning:
      "This JSON import can override existing configuration.",
    importAclJsonConfirmP2:
      "Depending on the file, matching records may be replaced for:",
    importAclJsonConfirmLi1: "Access controls (ACLs)",
    importAclJsonConfirmLi2: "Privileges",
    exportACLWithPrivilegesJson: "Export ACL with Privileges (JSON)",
    accessControl: {
      label: "Access Control",
      label1: "ACL",
      name: "Name",
      aclName: "ACL Name",
      quickSightManagement: 'Quicksight Management',
      dataManagement: 'Data Management',
      processManagement: 'Process Management',
      addQuicksight: "Add Quicksight Dashboards",
      quicksightTitle: "Quicksight Dashboards {{index}}",
      labelInPop1: "Module Name",
      labelInPop2: "Quicksight List",
      addProcessPrivileges: 'Add Process Template Privileges',
      editProcessPrivileges: 'Edit Process Template Privileges',
      labelInPop3: "Process Template",
      labelInPop4: "Domain",
      labelInPop5: "Actions",
      betweenDateError: `Both 'from' and 'to' date are required for {{fieldName}}`,
    },
    tip: {
      updateStatusSuccess:
        "Access Control Status has been updated successfully.",
      updateSuccess: "Access Control has been updated successfully.",
      addSuccess: "Access Control has been created successfully.",
      privilegeExists: "Privilege already exists.",
      exists: "Access Control already exists.",
      associatedSuccess: "Access Control has been associated successfully.",
      disassociatedSuccess:
        "Access Control has been disassociated successfully.",
      deleteSuccess: "Access Control has been deleted successfully.",
      exportACLConfigSuccess: "Access Control and Privilege Details exported successfully.",
    },
  },
  distributionManager: {
    distribution: "Distribution",
    distributionName: "Distribution Name",
    emailIdCount: "Email Id Count",
    recordID: 'Record ID',
    createdBy: "Created By",
    createdOn: "Created On",
    modifiedOn: "Modified On",
    description: "Description",
    searchAndEmail: "Search and Add Email ID",
    deleteDistribution: 'The selected distribution will be deleted. Do you wish to proceed?',
    tip: {
      addSuccess: "Distribution has been created successfully.",
      updateSuccess: "Distribution has been updated successfully.",
      deleteSuccess: "Distribution has been deleted successfully.",
      repeatError: "Please enter a unique email ID."
    },
    verify: {
      name: "Distribution Name is required",
    },
    identifiers: {
      title: "Manage Identifiers",
      tagTitle: "identifiers"
    }
  },
  clientManager: {
    client: "Client",
    addClient: "Add Client",
    clientInformation: "Client Information",
    clientName: "Client Name",
    clientNameHint:
      "Names are limited to 128 characters or fewer. Names may only contain alphanumeric characters, spaces, and the following special characters: + = , . @ -",
    clientId: "Client ID",
    clientSecret: "Client Secret",
    host: "Host",
    scope: "Scope",
    addExampleCodeTitle: "Add the example code to your application",
    getAccessTokenDescription: "Get an access token with a custom scope.",
    showClientSecret: "Show client secret",
    hideClientSecret: "Hide client secret",
    copyClientSecret: "Copy Client Secret",
    copyClientId: "Copy Client ID",
    copyHost: "Copy Host",
    copyScope: "Copy Scope",
    copyConnectionInfo: "Copy connection information",
    copyExampleCode: "Copy example code",
    roles: "Roles",
    role: "Role",
    addRole: "Add Role",
    removeRole: "Remove Role",
    deleteClient: "The selected client will be deleted. Do you wish to proceed?",
    deleteClientWithDependency:
      "Are you sure you want to delete this client as it has dependencies?",
    clientQuotaReached:
      "The maximum number of clients is {{quota}}. If you need to add more clients, please contact the Freya Fusion Support Team.",
    tip: {
      addSuccess: "Client has been created successfully.",
      updateSuccess: "Client has been updated successfully.",
      addRoleSuccess: "Role has been added successfully.",
      removeRoleSuccess: "Role has been removed successfully.",
      deleteSuccess: "Client has been deleted successfully.",
      clientSecretCopied: "Client Secret copied to clipboard.",
      clientSecretCopyFailed: "Unable to copy Client Secret.",
      clientSecretQueryFailed: "Unable to retrieve the Client Secret. Please try again.",
      clientIdCopied: "Client ID copied to clipboard.",
      clientIdCopyFailed: "Unable to copy Client ID.",
      hostCopied: "Host copied to clipboard.",
      hostCopyFailed: "Unable to copy Host.",
      scopeCopied: "Scope copied to clipboard.",
      scopeCopyFailed: "Unable to copy Scope.",
      connectionInfoCopied: "Connection information copied to clipboard.",
      connectionInfoCopyFailed: "Unable to copy connection information.",
    },
    verify: {
      clientName: "Client Name is required",
      clientNameFormat:
        "Names are limited to 128 characters or fewer. Names may only contain alphanumeric characters, spaces, and the following special characters: + = , . @ -",
      clientId: "Client ID is required",
    },
  },
  audit: {
    label: "Audit Reports",
    labelNew: "System Audit Trail",
    description:
      "Audit Reports keeps a track of all the activities and events in the system for security and accountability purposes.",
    filter: {
      startDate: "Start Date",
      endDate: "End Date",
      startDateTime: "Start DateTime",
      endDateTime: "End DateTime",
    },
    grid: {
      auditIdentifier: "Audit Identifier",
      auditIdentifierNew: "Audit Record",
      moduleName: "Module",
      operatorUsername: "User",
      operationType: "Operation Type",
      operationDate: "Operation Date and Time",
      entityIdentifier: "Entity Identifier",
      entityIdentifierNew: "Record ID",
      entityName: "Entity Name",
      fieldName: "Field Name",
      reason: "Reason",
      beforeModification: "Before Modification",
      afterModification: "After Modification",
      notes:
        "Note: This table only contains the fields which were updated during this transaction",
    },
    compareAudit: "Compare Audit",
    truncateFileTip: " ... Content truncated due to size limit. Displaying {{maxLines}} of {{totalLines}} total lines.",
    exportLimitExceeded: {
      title: "Export Limit Exceeded",
      message: "The total record count exceeds the limit of {{limit}}. Please apply a date range filter to reduce the number of records before exporting.",
    }
  },
  report: {
    module: 'Module',
    reportType: 'Report Type',
    reportName: 'Report Name',
  },
  systemSettings: {
    title: "Settings",
    sessionTimeOut: {
      logout: 'Your session is about to expire. Please log in again.',
      title: 'Session Timeout',
      prompt: 'Your session is about to expire. Do you want to extend your session?',
      min: 'Min',
      sec: 'Sec'
    }
  },
  notification: {
    domainName: "Domain Name",
    moduleName: "Module Name",
    fieldName: "Field Name",
    templateId: "Template Id",
    templateName: "Template Name",
    createdDate: "Created Date",

    payloads: "Payloads",
    payloadId: "Payload ID",
    notificationPayload: "Notification Payload",
    remarks: "Remarks",
    status: "Status",

    tasks: "Tasks",
    taskId: "Task ID",
    taskType: "Task Type",
    scheduledDate: "Past Scheduled Date",
    lastScheduledDate: "Upcoming Scheduled Date",
    endDate: "End Date",

    history: "History",
    notificationContent: "Notification Content",
    receiver: "Receiver",

    Templates: "Templates",
    cancelTask: "Cancel Task",
    tips: {
      copiedSuccess: "Copied successfully",
      cancelSucess: "Task canceled successfully",
      cancelConfirm: 'The selected task shall be <b class="alert-text">Cancel</b>. <br /> Do you wish to proceed?',
    },

    basic: {
      tab: "Template Configuration",
      title: "List of templates to create notification",
      addTemplate: "Add Template",
      editTemplate: "Edit Template",
      templatedescription: "Template description",
      notificationType: "Notification Type",
      notificationChannels: "Notification Channels",
      condition: "Condition",
      interval: "Interval",
      intervalUnit: "Interval Unit",
      frequency: "Occurrence",
      notificationDisabled: "Template Inactivate",
      deleteTemplate: "Delete Template",
      tips: {
        deleteSuccess: "Template deleted successfully",
        deleteOne: "Please select the data you want to delete",
        deleteConfirm: 'The selected template shall be <b class="alert-text">Deleted</b>. <br /> Do you wish to proceed?',
        updatedSuccess: "Template updated successfully",
        addSuccess: "Template added successfully"
      }
    },
    conditions: {
      tab: "Conditions",
      addCondition: "Add Condition",
      conditionField: "Condition Field",
      operator: "Operator",
      value: "Value",
      tips: {
        addAtAime: "Only one new line can be added at a time",
        addSuccess: "Condition added successfully",
        updatedSuccess: "Condition updated successfully",
        deleteSuccess: "Condition deleted successfully",
      }
    },
    content: {
      tab: "Template Content",
      subjectTitle: "Subject Title",
      templateTitle: "Template Title",
      templateContent: "Template Content",
      email: "Email",
      fields: "Fields",
      tips: {
        updatedSuccess: "Template content updated successfully",
      }
    },
  },
  processManager: {
    template: "Template",
    id: "Process Template ID",
    processTemplateName: "Process Template Name",
    processType: "Process Type",
    processTemplateDescription: "Process Template Description",
    processTemplateVersion: "Process Template Version",
    editDetails: "Edit Template",
    addDetails: "Add Template",
    editBPMN: "Edit BPMN",
    domains: "Process Template Domains",
    addBPMN: "Add BPMN",
    taskManager: {
      taskProperties: 'Task Properties',
      taskId: "Task ID",
      taskName: "Task Name",
      displayName: "Display Name",
      moduleName: "Module Name",
      domainName: "Domain Name",
      updateName: "Update Display Name",
      order: "Order",
      propertyName: "Property Name",
      property: "Property",
      configurability: "Configurability",
      fixed: "Fixed",
      configurable: "Configurable",
      configurabilityInfo: "Fixed means the field value cannot be changed during process execution and Configurable allows the value to be overridden during runtime.",
      detailsPage: {
        sectionTitle: "Process Detail Page Configuration",
        visibility: "Visibility",
        visibilityInfo: "The 'Visibility' field determines whether this field is displayed on the Process Details page."
      }
    }
  },
  appLauncher: {
    app: {
      title: "Freya Fusion",
      subTitle: "Access business modules and core features",
    },
    tenant: {
      title: "Platform",
      subTitle: "Freyr admin manages platform-level configurations",
    },
  },
  taskManager: {
    tag: 'Tags',
    key: 'Key',
    value: 'Value',
    remove: 'Remove',
    addTag: 'Add Tag',
    verify: {
      empty: "This is a required field.",
      unique: 'Each Key must be unique.'
    },
    successTip: 'Tags saved successfully.'
  },
  // Identifier
  filter: {
    clear: "Clear",
    searchIntro: "You can select/unselect to filter content.",
    selected: "Selected",
    beforeThanPlaceholder: "Select date",
    more: "More",
    total: "Total",
    filterItems: {
      label: "Identifiers",
      totalLabel: "Total identifiers",
      searchPlaceholder: "Search identifiers",
    },
  },
  modal: {
    editIdentifiers: {
      title: "Manage Identifiers"
    }
  }
};
